<div class="custom-table-container">
  <!-- <mat-form-field class="me-2" appearance="fill">
    <mat-label>{{ 'PARKING_PRICING.PARKINGS' | transloco }}</mat-label>
    <mat-select [(value)]="parkingPricingId" (selectionChange)="changeParking($event.value)">
      <mat-option *ngFor="let parking of organization.config.parkings" [value]="parking.parkingId">
        {{parking.parkingName}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <button [disabled]="isLoading" class="mb-2 me-2" mat-stroked-button color="primary"
    (click)="openBulkUpdateParkingPricingModal()">
    <mat-icon>edit</mat-icon> {{ 'PARKING_PRICING.FORM.BULK_UPDATE_PARKING_PRICING' | transloco }}
  </button> -->

  <div class="custom-table-heading-container">
    <mat-icon class="icon-bottom">local_parking</mat-icon>
    {{'PARKING_PRICING.TITLE' | transloco}}
  </div>
  <div class="overflow-auto">
    <table mat-table class="custom-table"
      [dataSource]="parkingPricingList()?.length > 0 ? dataSource : emptyData" matSort>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PARKING_PRICING.CODE' | transloco}}</th>
        <td mat-cell *matCellDef="let element">{{element.code}}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PARKING_PRICING.NAME' | transloco}}</th>
        <td mat-cell *matCellDef="let element">{{element.name}}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PARKING_PRICING.DESCRIPTION' | transloco}}</th>
        <td mat-cell *matCellDef="let element">{{element.description}}</td>
      </ng-container>

      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PARKING_PRICING.PRICE' | transloco}}</th>
        <td mat-cell *matCellDef="let element">{{element.price | number:'1.2-2'}}</td>
      </ng-container>

      <ng-container matColumnDef="vat">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PARKING_PRICING.VAT' | transloco}} (%)</th>
        <td mat-cell *matCellDef="let element">{{element.vat | number:'1.2-2'}}</td>
      </ng-container>

      <ng-container matColumnDef="totalPrice">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PARKING_PRICING.TOTAL_PRICE' | transloco}}</th>
        <td mat-cell *matCellDef="let element">{{element.totalPrice | number:'1.2-2'}}</td>
      </ng-container>

      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PARKING_PRICING.ACTIVE' | transloco}}</th>
        <td mat-cell *matCellDef="let element">
          <mat-icon [style.color]="element.active ? 'green' : 'red'">
            {{element.active ? 'check_circle' : 'cancel'}}
          </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="productTypeName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PARKING_PRICING.PRODUCT_TYPE' | transloco}}</th>
        <td mat-cell *matCellDef="let element">{{element.productTypeName | translateAttribute}}</td>
      </ng-container>

      <ng-container matColumnDef="empty-row">
        <td mat-cell class="no-data-cell" *matCellDef="let element">{{ 'ERROR.NO_DATA' | transloco }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsAdditionalServices"></tr>
      <tr mat-row
        *matRowDef="let row; columns: parkingPricingList()?.length > 0 ? displayedColumnsAdditionalServices : ['empty-row'];"
        (click)="openEditPricingModal(row)" class="clickable">
      </tr>
    </table>
  </div>
</div>
